import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://pochelo.online';

// Verde menta fuerte a claro para 8 máquinas
const COLORS = [
  '#00cba0', // Machine1 - verde menta fuerte
  '#33d6b3', // Machine2
  '#66e1c6', // Machine3
  '#99ecd9', // Machine4
  '#b3f2e1', // Machine5
  '#c6f7ea', // Machine6
  '#d9fcf3'
];

const MACHINES = [
  'Machine1', 'Machine2', 'Machine3', 'Machine4',
  'Machine5', 'Machine6', 'Machine7'
];

const BarAcumuladoDia = () => {
  const [chartData, setChartData] = useState({
    labels: MACHINES,
    datasets: []
  });

  useEffect(() => {
    const socket = io(SOCKET_URL, {
      auth: { token: localStorage.getItem('token') }
    });

    socket.emit('solicitarUltimoAcumuladoHoy');

    socket.on('ultimoAcumuladoHoy', (result) => {
      // Crea un diccionario para acceso rápido
      const dataDict = {};
      result.forEach(item => {
        dataDict[item.dispositivoId] = item.avanceRPM || 0;
      });

      // Ordena los datos según MACHINES
      const avance = MACHINES.map(id => dataDict[id] || 0);

      setChartData({
        labels: MACHINES,
        datasets: [
          {
            label: 'Acumulado Día',
            data: avance,
            backgroundColor: COLORS
          }
        ]
      });
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top', labels: { color: '#8ab0cc', font: { size: 9 } } },
      title: {
        display: true,
        text: 'Acumulado del Día por Máquina',
        color: '#8ab0cc',
        font: { family: 'Roboto', size: 10 }
      }
    },
    scales: {
      x: { grid: { color: 'rgba(30,90,180,0.2)', lineWidth: 0.5 }, ticks: { color: '#8ab0cc' } },
      y: { grid: { color: 'rgba(30,90,180,0.2)', lineWidth: 0.5 }, ticks: { color: '#8ab0cc' } }
    }
  };

  return <Bar data={chartData} options={options} height={280} />;
};

export default BarAcumuladoDia;